<template>
  <div>
    <ValidationObserver slim ref="form" v-if="step == 1">
      <form class="access-step1" @submit.prevent="onSubmitCheck">
        <p>
          <label for="rpps">N° RPPS</label>
          <ValidationProvider slim name="rpps" rules="required|length:11" v-slot="{ classes, errors }">
            <the-mask type="text" id="rpps" name="rpps" :class="classes"
                      mask="###########"
                      v-model="rpps"></the-mask>
            <span class="error-txt">{{ errors[0] }}</span>
          </ValidationProvider>
        </p>

        <input type="submit" value="Continuer"/>
      </form>
      <p v-if="error" class="error-txt">
        {{ error }}
      </p>
    </ValidationObserver>

    <ValidationObserver slim ref="form2" v-if="step == 2">
      <form class="access-step1" @submit.prevent="onSubmit">
        <p>
          <label for="rpps2">N° RPPS</label>
          <input type="text" name="rpps" id="rpps2" v-model="rpps" readonly/>
        </p>

        <p>
          <label for="client_arrow">Votre établissement est-il client du Laboratoire Arrow ?</label>
          <ValidationProvider slim name="client_arrow" rules="required" v-slot="{ classes, errors }">
            <select id="client_arrow" v-model="item.client_arrow">
              <option value="null">--- Choisissez ---</option>
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
            <span class="error-txt">{{ errors[0] }}</span>
          </ValidationProvider>
        </p>

        <p v-if="item.client_arrow == 0">
          <label for="profil">Quel est votre profil ?</label>
          <ValidationProvider slim name="profil" rules="required" v-slot="{ classes, errors }">
            <select id="profil" v-model="item.profil">
              <option value="null">--- Choisissez ---</option>
              <option value="officine">Pharmacien en officine</option>
              <option value="hopital">Pharmacien hospitalier</option>
            </select>
            <span class="error-txt">{{ errors[0] }}</span>
          </ValidationProvider>
        </p>

        <input type="submit" value="Continuer"/>

      </form>
      <p v-if="error" class="error-txt">
        {{ error }}
      </p>
    </ValidationObserver>

    <ValidationObserver slim ref="form3" v-if="step == 3">
      <form class="access-step1" @submit.prevent="onSubmit3">
        <p>
          <label for="rpps3">N° RPPS</label>
          <input type="text" name="rpps" id="rpps3" v-model="rpps" readonly/>
        </p>
        <p>
          <label for="profil">Quel est votre profil ?</label>
          <ValidationProvider slim name="profil" rules="required" v-slot="{ classes, errors }">
            <select id="profil" v-model="item.profil">
              <option value="null">--- Choisissez ---</option>
              <option value="medecin">Médecin de ville</option>
              <option value="medecin_hospitalier">Médecin hospitalier</option>
            </select>
            <span class="error-txt">{{ errors[0] }}</span>
          </ValidationProvider>
        </p>

        <input type="submit" value="Continuer"/>

      </form>
      <p v-if="error" class="error-txt">
        {{ error }}
      </p>
    </ValidationObserver>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask';
import Rpps from "../../services/Rpps";

export default {
  components: {TheMask},
  data() {
    return {
      step: 1,
      rpps: null,
      error: null,
      item: {
        rpps: null,
        profil: null,
        client_arrow: null,
      }
    }
  },
  mounted() {

  },
  methods: {
    onSubmitCheck() {
      this.error = null;
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.checkRpps();
      });
    },
    onSubmit() {
      if (this.item.client_arrow == "null") {
        this.item.client_arrow = null;
        this.item.profil = null;
      }
      if (this.item.client_arrow == "1") {
        this.item.profil = null;
      }
      if (this.item.profil == "null") {
        this.item.profil = null;
      }
      this.$refs.form2.validate().then(success => {
        if (this.item.client_arrow == "null" ||
            this.item.client_arrow == null ||
            (this.item.client_arrow == "0" && this.item.profil == "null") ||
            (this.item.client_arrow == "0" && this.item.profil == null)) {
          success = false;
        }
        if (!success) {
          return;
        }
        this.goToRegistration(true);
      });

    },
    onSubmit3() {
      this.$refs.form3.validate().then(success => {
        if (!success) {
          return;
        }
        this.goToRegistration(false);
      });
    },
    checkRpps() {
      Rpps.checkRpps(this.rpps).then((response) => {
        if (response.has_step2) {
          this.step = 2;
        } else {
          this.step = 3
          /*this.item.profil = 'medecin';
          this.goToRegistration(false)*/
        }
      }).catch((error) => {
        this.error = error.error;
      });
    },
    goToRegistration(has_step2) {
      let redirect = window.Routes.register + '?rpps=' + this.rpps + '&profil=' + this.item.profil;

      if (has_step2) {
        redirect += '&client_arrow=' + this.item.client_arrow;
      }

      window.location = redirect;
    }
  }
}
</script>

